import { type ErrorIntlConfig } from "../types/errorIntlConfig"
import { type Namespace } from "../types/namespace"
import { createFormatServerSideErrorCode } from "./createFormatServerSideErrorCode"
import { createFormatServerSideRequestError } from "./createFormatServerSideRequestError"
import { createUseFormatErrorCode } from "./createUseFormatErrorCode"
import { createUseFormatRequestError } from "./createUseFormatRequestError"

export function getErrorInltBuilder<TMessages>() {
    return function createErrorIntl<TNamespace extends Namespace<TMessages>>(
        config: ErrorIntlConfig<TMessages, TNamespace>
    ) {
        return {
            useFormatErrorCode: createUseFormatErrorCode<TMessages, TNamespace>(config),
            useFormatRequestError: createUseFormatRequestError<TMessages, TNamespace>(config),
            formatServerSideErrorCode: createFormatServerSideErrorCode<TMessages, TNamespace>(
                config
            ),
            formatServerSideRequestError: createFormatServerSideRequestError<TMessages, TNamespace>(
                config
            ),
        }
    }
}
